export const PHONE_1 = "+91 9810478236";
export const PHONE_2 = "+91 9821616979";
export const PHONE_1_LINK = "tel:+919810478236";
export const PHONE_2_LINK = "tel:+919821616979";
export const WHATSAPP_LINK =
  "https://wa.me/919821616979?text=" +
  encodeURIComponent(
    "Hello Jagdamba Enterprises, I have a hardware / industrial requirement and would like to discuss it with your team."
  );
export const ADDRESS_LINES = [
  "Main Garhi Road, near Aggarwal Sweets,",
  "Mamura Sector-66, Noida,",
  "Uttar Pradesh, India",
];
export const MAPS_LINK =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent(
    "Main Garhi Road, near Aggarwal Sweets, Mamura Sector-66, Noida, Uttar Pradesh, India"
  );

export const IMAGES = {
  hero: "/images/hero.png",
  fittings: "/images/fittings.png",
  texture: "/images/texture.png",
  tools: "/images/tools.png",
};

export const CATEGORIES = [
  {
    id: "01",
    name: "Bolts",
    img: "/images/cat-bolts.png",
    items: ["Hex Bolt", "Carriage Bolt", "Flange Bolt", "Lag Bolt", "Socket Bolt"],
  },
  {
    id: "02",
    name: "Nuts",
    img: "/images/cat-nuts.png",
    items: [
      "Hex Nut",
      "Square Nut",
      "Flange Nut",
      "Nylon Nut",
      "Wing Nut",
      "Cap Nut",
      "Castle Nut",
      "Eye Nut",
    ],
  },
  {
    id: "03",
    name: "Screws",
    img: "/images/cat-screws.png",
    items: ["Self-Drilling Screws", "Drywall Screws", "Clipboard Screws", "Wood Screws"],
    note: "Common screw heads: Philips, Star, Torx, Slotted, Square, Truss, Dome, Flat",
  },
  {
    id: "04",
    name: "Anchors & Fixings",
    img: "/images/cat-anchors.png",
    items: [
      "Pin Type Anchor",
      "Wedge Anchor",
      "Drop-In Anchor",
      "Rawal Bolt / Rawal Shell",
      "Nylon Frame Fixing",
      "TAM Anchor",
      "Blind Rivet",
    ],
  },
  {
    id: "05",
    name: "Oils",
    img: "/images/cat-oils.png",
    items: ["Hydraulic Oil", "Machine Oil", "Gear Oil"],
    note: "Available in small packing to drums (barrels).",
  },
  {
    id: "06",
    name: "Electrical Items",
    img: "/images/cat-electrical.png",
    items: [
      "PVC Junction Box",
      "GI Junction Box",
      "PVC Flexible Conduit",
      "PVC Conduit Pipe & Bends",
      "PVC Casing & Capping",
      "PVC Gitti",
      "PVC Tape",
      "Cable Tray",
      "Saddle Clamp",
    ],
  },
  {
    id: "07",
    name: "Tools",
    img: "/images/tools.png",
    items: [
      "Screwdrivers",
      "Pliers",
      "Wire Stripper",
      "Voltage Tester",
      "Measuring Tape",
      "Level",
      "Splice Connector",
      "Fish Tape",
    ],
  },
  {
    id: "08",
    name: "Safety & Welding",
    img: "/images/cat-safety.png",
    items: [
      "Safety Gloves",
      "Fire-Retardant Shirt",
      "Welding Rods",
      "Welding Machine",
      "Cutting Wheel",
    ],
    note: "Material availability: MS / GI / SS",
  },
];

export const BRANDS_AUTHORIZED = [
  { name: "IndianOil", logo: "/brands/indianoil.png" },
  { name: "HP", logo: "/brands/hp.png" },
];

export const BRANDS_ASSOCIATIONS = [
  { name: "Taparia", logo: "/brands/taparia.png" },
  { name: "HCH", logo: "/brands/hch.png" },
  { name: "Multitec", logo: "/brands/multitec.png" },
  { name: "SKF", logo: "/brands/skf.png" },
  { name: "Pidilite", logo: "/brands/pidilite.png" },
  { name: "Mangalam", logo: "/brands/mangalam.png" },
  { name: "Superon", logo: "/brands/superon.png" },
  { name: "Tiger" },
  { name: "Bosch", logo: "/brands/bosch.png" },
  { name: "Fenner" },
  { name: "OMFA Rubber Products" },
  { name: "Venus" },
];

export const INDUSTRIES = [
  {
    id: "01",
    title: "Manufacturing Companies",
    desc: "For businesses regularly requiring hardware and industrial supplies.",
  },
  {
    id: "02",
    title: "Construction & Project Companies",
    desc: "For project and construction requirements.",
  },
  {
    id: "03",
    title: "Industrial Maintenance",
    desc: "For maintenance departments requiring dependable hardware and supplies.",
  },
  {
    id: "04",
    title: "Machine Service Engineers",
    desc: "For machine service and maintenance requirements.",
  },
  {
    id: "05",
    title: "Workshops & Professionals",
    desc: "For professional craftsmen and workshop requirements.",
  },
];

export const CLIENTS = [
  { name: "Vulcan AIC", logo: "/clients/vulcan-aic.png" },
  { name: "Giftreeng Innovations", logo: "/clients/giftreeng.png" },
  { name: "Vyomana Aerospace", logo: "/clients/vyomana.png" },
  { name: "Bansal Wire", logo: "/clients/bansal-wire.png" },
  { name: "Orientbell", logo: "/clients/orientbell.png" },
  { name: "Geogres Construction Chemical", logo: "/clients/geogres.png" },
];

export const WHY_POINTS = [
  "On-Time Delivery",
  "Wide Product Range",
  "Genuine & Durable Products",
  "Customer-First Approach",
  "Trusted Brand Partnerships",
  "Competitive Pricing",
];

export const LEADERSHIP = [
  { name: "Pawan Garg", role: "Founder", photo: "/team/pawan-garg.jpg" },
  { name: "Harsh Garg", role: "Co-Founder", photo: "/team/harsh-garg.jpg" },
];

export const VISION =
  "To become a respected leader in the hardware supply industry, known for integrity, innovation, and a customer-first approach.";

export const MISSION =
  "To provide high-quality hardware and tools that enhance productivity, reliability, and growth for industries, workshops, and professional craftsmen.";

export const ABOUT_COPY_1 =
  "Jagdamba Enterprises is a trusted supplier of quality hardware, tools, and industrial solutions serving businesses, workshops, and professionals.";

export const ABOUT_COPY_MANUFACTURER =
  "Beyond supply, Jagdamba Enterprises is also a manufacturer of nuts, bolts, washers and more.";

export const ABOUT_COPY_2 =
  "We focus on delivering durable products, reliable service, and customer-centric support. With a strong commitment to excellence, we ensure smooth operations for industries through dependable and efficient supply solutions.";
